<template>
  <div>
    <div v-if="payload.is_create">
      <div>
        <p class="bold">Education Course</p>
        <select v-model="education_course_id">
          <option
            :key="'education_course_' + education_course.id"
            v-for="education_course in education_courses"
            :value="education_course.id"
            >{{ education_course.name }}
          </option>
        </select
        >
      </div>
      <div>
        <p class="bold">Education Degree</p>
        <select v-model="education_degree_id">
          <option
            :key="'education_degree_' + education_degree.id"
            v-for="education_degree in education_degrees"
            :value="education_degree.id"
            >{{ education_degree.name }}
          </option>
        </select
        >
      </div>
      <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.6); padding-bottom: 20px; margin-top: 30px;">
        <div class="is-flex is-align-items-center">
          <p><b>Universities</b></p>
          <div style="width: 20px;"></div>
          <checkbox v-model="with_honors_university">with honors</checkbox>
          <div style="width: 20px;"></div>
          <input v-model="grade_university" style="width: 170px;" class="outlined" placeholder="לדוגמה... 96">
          <div style="width: 20px;"></div>
          <a @click="overwrite('university')" class="button is-info">Overwrite</a>
        </div>
        <div style="margin-top: 10px;" class="is-flex is-align-items-center">
          <p><b>Top Colleges</b></p>
          <div style="width: 20px;"></div>
          <checkbox v-model="with_honors_top_college">with honors</checkbox>
          <div style="width: 20px;"></div>
          <input v-model="grade_top_college" style="width: 170px;" class="outlined" placeholder="לדוגמה... 96">
          <div style="width: 20px;"></div>
          <a @click="overwrite('top_college')" class="button is-info">Overwrite</a>
        </div>
        <div style="margin-top: 10px;" class="is-flex is-align-items-center">
          <p><b>All Other Institutions</b></p>
          <div style="width: 20px;"></div>
          <checkbox v-model="with_honors_other">with honors</checkbox>
          <div style="width: 20px;"></div>
          <input v-model="grade_other" style="width: 170px;" class="outlined" placeholder="לדוגמה... 96">
          <div style="width: 20px;"></div>
          <a @click="overwrite('other')" class="button is-info">Overwrite</a>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <div v-for="education in educations" :key="'education_' + education.education_institution.id" class="is-flex is-align-items-center"
             style="margin-bottom: 10px; border-bottom: 1px solid rgba(0, 0, 0, 0.1); padding-bottom: 10px;">
          <checkbox v-model="education.selected" :checked="education.selected"><b>{{ education.education_institution.name }}</b></checkbox>
          <div style="width: 30px;"></div>
          <checkbox v-model="education.with_honors" :checked="education.with_honors">with honors</checkbox>
          <div style="width: 30px;"></div>
          <input v-model="education.grade" style="width: 170px;" class="outlined" placeholder="לדוגמה... 96">
        </div>
      </div>
    </div>
    <div v-if="edit_form">
      <div>
        <checkbox v-model="edit_form.with_honors" :checked="edit_form.with_honors">with_honors</checkbox>
      </div>
      <div>
        <p><b>Grade</b></p>
        <input v-model="edit_form.grade" class="outlined">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
export default {
  props: ['payload'],
  name: 'educations-form',
  data () {
    return {
      education_course_id: 0,
      education_degree_id: 0,
      is_loading: false,
      education_institutions: [],
      education_courses: [],
      education_degrees: [],
      educations: [],
      grade_university: '',
      grade_top_college: '',
      grade_other: '',
      with_honors_university: false,
      with_honors_top_college: false,
      with_honors_other: false,
      edit_form: undefined,
      api_path: this.payload.is_position ? ('/positions/' + this.payload.position_id) : '/companies'
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    getInitCourseId () {
      for (let i = 0; i < this.education_courses.length; i++) {
        let education_course = this.education_courses[i]
        if (education_course.name == this.$settings.get({ path: 'pages.company.education.default_education_course' })) {
          return education_course.id
        }
      }
    },
    getInitDegreeId () {
      for (let i = 0; i < this.education_degrees.length; i++) {
        let education_degree = this.education_degrees[i]
        if (education_degree.name == this.$settings.get({ path: 'pages.company.education.default_education_degree' })) {
          return education_degree.id
        }
      }
    },
    overwrite (institution_type) {
      return this.educations.filter(education => {
        if (education.institution_type != institution_type) {
          return
        }
        education.selected = true
        education.grade = this['grade_' + institution_type]
        education.with_honors = this['with_honors_' + institution_type]
        return education
      })
    },
    setEditForm () {
      let request_name = this.payload.is_position ? 'getPositionEducation' : 'getCompanyEducation'
      this.$network_utils[request_name]({ education_id: this.payload.data.id, position_id: this.payload.position_id, current_company_id: this.payload.company_id })
        .then(response => {
          this.edit_form = {
            with_honors: response.with_honors,
            grade: response.grade
          }
        })
    },
    init () {
      this.$network_utils.getAllEducationInstitutions().then(response => {
        this.education_institutions = response
        if (this.payload.is_create) {
          this.setEducations()
          return
        }
        this.setEditForm()
      })
      this.$network_utils.getAllEducationCourses().then(response => {
        this.education_courses = response
        this.education_course_id = this.getInitCourseId()
      })
      this.$network_utils.getAllEducationDegrees().then(response => {
        this.education_degrees = response
        this.education_degree_id = this.getInitDegreeId()
      })
    },
    setEducations () {
      for (let i = 0; i < this.education_institutions.length; i++) {
        let education_institution = this.education_institutions[i]
        let institution_type = ['university', 'top_college'].includes(education_institution.institution_type) ? education_institution.institution_type : 'other'
        this.educations.push({
          institution_type: institution_type,
          education_institution: education_institution,
          selected: false,
          with_honors: false,
          grade: ''
        })
      }
    },
    getRequestParams (params) {
      return {
        current_company_id: this.payload.company_id,
        position_id: this.payload.position_id,
        education_institution_id: params.education_institution_id,
        grade: params.grade,
        with_honors: params.with_honors,
        education_degree_id: this.education_degree_id,
        education_course_id: this.education_course_id
      }
    },
    getEditRequests () {
      return [this.$caller.request('put', this.api_path + '/educations/' + this.payload.data.id, 'company_headers', this.getRequestParams({
        education_institution_id: this.payload.data.education_institution.id,
        grade: this.edit_form.grade,
        with_honors: this.edit_form.with_honors
      }))]
    },
    getPostRequests () {
      let requests = []
      for (let i = 0; i < this.educations.length; i++) {
        let education = this.educations[i]
        if (!education.selected) {
          continue
        }
        requests.push(this.$caller.request('post', this.api_path + '/educations/', 'company_headers', this.getRequestParams({
          education_institution_id: education.education_institution.id,
          grade: education.grade,
          with_honors: education.with_honors
        })))
      }
      return requests
    },
    submit () {
      let type = this.payload.is_create ? 'Post' : 'Edit'
      let requests = [...this['get' + type + 'Requests']()]
      if (requests.length == 0) {
        return
      }
      this.is_loading = true
      this.$caller.axios.all(requests).then(() => {
        if (this.payload.is_position) {
          this.$network_utils.sendPositionUpdateEvent({ position_id: this.payload.positon_id, company_id: this.payload.company_id, status: this.payload.position_status })
        }
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Checkbox
  }
}
</script>
